import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styles from './Nav.module.css';

const App: React.FC = () => {
  function CustomerLogin(): void {
    setLogin(true);
  }
  function EmployeeLogin(): void {
    setLogin(false);
  }

  const callBackendAPI = async (): Promise<any> => {
    const response = await fetch('https://soarin-donuts-backend.fly.dev/api/donuts');
    const data = await response.json();

    if (response.status === 404) {
      throw new Error('Status 404 received');
    }

    return data;
  };

  function logDonuts(): void {
    callBackendAPI()
      .then(data => {
        console.log(data);
      })
      .catch(error => {
        console.error(error);
      });
  }

  logDonuts();
  console.log('after method\n');
  const [login, setLogin] = useState(true);
  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Soarin Donuts Login</h1>
      <button key={0} onClick={CustomerLogin} className={login.valueOf() ? styles.on : styles.off }>Customer </button>
      <button key={1} onClick={EmployeeLogin} className={login.valueOf() ? styles.off : styles.on}> Employee</button>
      <br />
      <form>
        <input className={styles.inpt} key='login' placeholder={login.valueOf() ? 'Customer Username' : 'Employee Username'}></input>
        <input className={ styles.inpt} key='password' placeholder={'Password'}></input>
        <Link className={ styles.btn} to={login.valueOf() ? '/menu' : '/employee'}>Submit</Link>
      </form>
    </div>
  )
}

export default App
